import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { DocumentsListPage } from '@/features/documents/documents-list-page'

const searchSchema = z.object({
  q: z.string().optional(),
  status: z.string().optional(),
  payment: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  branchId: z.string().optional(),
  page: z.number().int().min(1).optional(),
})

export const Route = createFileRoute('/_app/tickets')({
  staticData: { crumb: 'Tiquetes' },
  validateSearch: searchSchema,
  component: Page,
})

function Page() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <DocumentsListPage
      kind="TE"
      title="Tiquetes electrónicos"
      description="Ventas a consumidor final."
      newLabel="Nuevo tiquete"
      search={search}
      onSearch={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
    />
  )
}
